import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsAdvisersWebLinkListItemCls: string;
		}
	},

	slug: string
}

class List extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Advisers List Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '1', 'investors_advisers_list', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '2', 'investors_advisers_list', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '3', 'investors_advisers_list', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '4', 'investors_advisers_list', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '5', 'investors_advisers_list', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '6', 'investors_advisers_list', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsAdvisersWebLinkListItemCls + '7', 'investors_advisers_list', { animCls: 'animate__fadeInLeft25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default List;